import { handleChannelNavigation } from '../../utils';
import { ChannelPopup, ChannelShieldtick, ChannelEyeslash, Channeldiscover } from '../../../assets/images';

function CreateChannelPopup() {
    const navigatetoCreateChannel = () => {
        handleChannelNavigation({ pane: 'createChannel' });
    };
    const closePopup = () => {
        handleChannelNavigation({ pane: 'recentChannelList' });
    };
    return (
        <>
            <div className="channel_createpopup">
                <div className="bg_popup">
                    <i>
                        <ChannelPopup />
                    </i>
                    <div className="popup_title">
                        <h3>Create a channel to reach unlimited followers</h3>
                    </div>
                    <div className="channel_content">
                        <ul>
                            <li>
                                <i>
                                    <Channeldiscover />
                                </i>
                                <div className="channel_mini">
                                    <h4>Anyone can reach your channel</h4>
                                    <p>Channels are public, so anyone can find them and see 30 days of history</p>
                                </div>
                            </li>
                            <li>
                                <i>
                                    <ChannelEyeslash />
                                </i>
                                <div className="channel_mini">
                                    <h4>People see your channel, not you</h4>
                                    <p>
                                        Followers can’t see your phone number, profile picture or name, but other admins
                                        can.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <i>
                                    <ChannelShieldtick />
                                </i>
                                <div className="channel_mini">
                                    <h4>You are responsible for you channel</h4>
                                    <p>
                                        Your channel needs to follow our <span>guidelines</span> and is reviewed against
                                        them.
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="popup_btn">
                        <button onClick={closePopup}>Close</button>
                        <button className="plus" onClick={navigatetoCreateChannel}>
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default CreateChannelPopup;
